module.exports = __webpack_public_path__ + "img/7.390c49f7.jpg";